import api from "@/lib/api";

// Store a ?ref=CODE from the URL so it survives until the user signs up.
export function captureReferral() {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("nc_ref", ref.trim());
  } catch {
    /* ignore */
  }
}

// After a successful signup/login, redeem any stored referral code (once).
export async function applyStoredReferral() {
  let code;
  try {
    code = localStorage.getItem("nc_ref");
  } catch {
    code = null;
  }
  if (!code) return;
  try {
    await api.post("/referral/apply", { code });
  } catch (e) {
    console.error("Referral apply failed", e);
  } finally {
    try { localStorage.removeItem("nc_ref"); } catch { /* ignore */ }
  }
}
